module.exports = __webpack_public_path__ + "static/media/16-mercedes.e61ccb38.jpg";